import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_REACT_APP_SERVER_URL,
});

// İSTEK: Token ekleme
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const res = await axios.post(
          import.meta.env.VITE_REACT_APP_SERVER_URL + "refresh-token",
          { token: refreshToken },
        );

        // Değişken ismini 'res' olarak düzelttik
        if (res.status === 200 || res.status === 201) {
          const newToken = res.data.token; // Düzeltildi
          const newRefreshToken = res.data.refreshToken; // Düzeltildi

          localStorage.setItem("token", newToken);
          localStorage.setItem("refreshToken", newRefreshToken);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error("Refresh hatası:", refreshError);
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
